import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles(theme => ({
    bottomCellIcon: {
        position: 'absolute',
        right: '15%',
        top: 'calc(50% - 11px)'
    },
    greenIcon: {
        color: theme.palette.green.main
    },
    hide: {
        display: 'none'
    },
    leftCell: {
        minWidth: '180px'
    },
    redIcon: {
        color: theme.palette.red.main,
        transform: 'rotate(-90deg)'
    },
    root: {
        height: '100%',
        overflow: 'auto',
        width: '100%'
    },
    table: {
        height: '100%'
    },
    tableBottomCell: {
        backgroundColor: theme.palette.grey.light,
        bottom: 0,
        position: 'sticky',
        zIndex: 10
    },
    tableHeadCell: {
        backgroundColor: theme.palette.grey.light
    }
}));
